import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import homeLogo from "../../Assets/main-home.svg";
import Type from "./Type";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refreshHard();

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home" name="home">

        <Container className="home-content">
          <Row>
            <Col
              md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hello
              </h1>

              <h1 className="heading-name">
                I am
                <strong className="main-name"> Ravi Ranjan</strong>
              </h1>

              <div style={{ textAlign: "left", lineHeight: 0 }} className="heading_text_main">
                <Type />
              </div>

              <Row className="heading_home_social_main">
                <ul className="home-about-social-links">
                  <li className="social-icons">
                    <a
                      href="https://github.com/Ravi-047"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <AiFillGithub />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="https://www.linkedin.com/in/ravi-ranjan-136844231/"
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  <li className="social-icons">
                    <Button
                      className="resume-btn-inner"
                      onClick={() =>
                        window.open("https://drive.google.com/file/d/1SAnnSyXDNcvnpEfK_vkkeL6R80kvRtZT/view?usp=share_link")}
                      href="/Ravi-Ranjan-Ram-Resume.pdf"
                      download
                    >
                      Resume
                    </Button>
                  </li>
                </ul>
              </Row>
            </Col>



            <Col md={4} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid heroImage"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
